import React, { useState, useEffect, useRef } from 'react';
import { get_builders } from '../api';

const BatchDropdown = ({ selectedItems, setSelectedItems }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isNoResult, setNoResult] = useState(false);
  const [options, setOptions] = useState([]);
  const dropdownRef = useRef(null);
  const allOption = 'All';

  useEffect(() => {
    const fetchBuilders = async () => {
      try {
        const builders = await get_builders();
        setOptions(builders);
      } catch (error) {
        console.error('Error fetching builders:', error);
        setNoResult(true);
      }
    };
    fetchBuilders();
  }, []);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleCheckboxChange = (option) => {
    setSelectedItems((prevSelectedItems) => {
      if (option === allOption) {
        return prevSelectedItems.includes(allOption) ? [] : [allOption];
      } else {
        if (prevSelectedItems.includes(option)) {
          const updatedSelection = prevSelectedItems.filter((item) => item !== option);
          if (prevSelectedItems.includes(allOption)) {
            return updatedSelection.filter((item) => item !== allOption);
          }
          return updatedSelection;
        } else {
          let updatedSelection = [...prevSelectedItems.filter((item) => item !== allOption), option];
          if (prevSelectedItems.includes(allOption)) {
            updatedSelection = options.filter((opt) => opt !== option);
          }
          const isAllSelectedNow = options.every((opt) => updatedSelection.includes(opt));
          return isAllSelectedNow ? [allOption] : updatedSelection;
        }
      }
    });
  };

  const isAllSelected = selectedItems.includes(allOption);
  const displayText = selectedItems.length === 0 ? 'Batch Name' : isAllSelected ? allOption : selectedItems.join(', ');

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className="self-evaluation-dd">
      <div
        onClick={handleToggle}
        className={`po2frms-batch-name ${isOpen ? 'active' : ''} ${isNoResult ? 'errorpo2frms-batch-error' : ''}`}
      >
        {displayText}
      </div>
      {isOpen && (
        <div className="self-evaluation-option">
          <label>
            <input type="checkbox" checked={isAllSelected} onChange={() => handleCheckboxChange(allOption)} />
            {allOption}
          </label>
          {options.map((option) => (
            <label key={option}>
              <input
                type="checkbox"
                checked={isAllSelected || selectedItems.includes(option)}
                onChange={() => handleCheckboxChange(option)}
              />
              {option}
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default BatchDropdown;
